import { getBrandingColorPalette } from '../../../base/styles';


export const colorsHangup = interfaceConfig => {
    return {
        white: '#fff',
        blackColor: '#233b4f',
        textColor: interfaceConfig?.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig).accent1 : '#fff',
        hangUpRed: getBrandingColorPalette(interfaceConfig).accent2,
        hangupPrimary: getBrandingColorPalette(interfaceConfig).primary,
        hangUpHover: `${getBrandingColorPalette(interfaceConfig).accent3}ad`
    };
};

